import dayjs from "dayjs"

// round a time string up to the nearest fraction of an hour
export function roundTimeUp(timeString: string, minutesPerCell: number) {
  const minutes = dayjs(timeString).millisecond() / 60000

  const nearestSubdivision = Math.ceil(minutes / minutesPerCell)
  const lastHour = dayjs(timeString).startOf("hour")
  return lastHour.add(
    nearestSubdivision * minutesPerCell,
    "minutes",
  )
}
